module.exports = __webpack_public_path__ + "img/we_make_pans.b57346c9.png";